export function initPreloader() {
  let preloader = document.getElementById('vfit-preloader');
    preloader.classList.add('hidden');
    setTimeout(function() {
      preloader.remove();
    }, 300);
}